module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Close_Light Blue.812bb738.svg";